import { createSlice } from '@reduxjs/toolkit';

import { initialState } from '../constants';

export const rosterLiteSlice = createSlice({
  name: 'rosterLite',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase('context/SET_ORGANIZATION', () => initialState);
  },
});

export const rosterLiteReducer = rosterLiteSlice.reducer;
